import { render } from "./AdBanner.vue?vue&type=template&id=3bf9cec0"
import script from "./AdBanner.vue?vue&type=script&lang=js"
export * from "./AdBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__